// extracted by mini-css-extract-plugin
export default {"BreadcrumbContainer":"breadcrumb_BreadcrumbContainer__iLxy1","Breadcrumb":"breadcrumb_Breadcrumb__Rz1LX","CurrentPage":"breadcrumb_CurrentPage__ZQ8Va"};